<template>
  <v-container fluid>
    <v-layout column>
      <v-data-table
        dense
        :headers="headers"
        :items="commissionReportItems"
        :items-per-page="-1"
        class="elevation-2"
      >
        <template v-slot:item.totalCommission="{ item }">
          {{ item.totalCommission | currency }}
        </template>
        <template v-slot:item.totalIndividualGP="{ item }">
          {{ item.totalIndividualGP | currency }}
        </template>
        <template v-slot:item.consultantsGP="{ item }">
          {{ item.consultantsGP | currency }}
        </template>
        <template v-slot:item.permPlacementsGP="{ item }">
          {{ item.permPlacementsGP | currency }}
        </template>
        <template v-slot:item.commissionOverride="{ item }">
          {{ item.commissionOverride | currency }}
        </template>
        <template v-slot:item.actions="{ item }">
          <v-btn
            class="hide-on-print mx-1 my-1"
            color="primary"
            outlined
            @click.prevent="viewCommissionDetails($event, item)"
          >
            <v-icon color="primary">paid</v-icon>
          </v-btn>
        </template>
      </v-data-table>
    </v-layout>
  </v-container>
</template>

<script>
import { mapFields } from '@/vueHelpers/vuex'
import { commissionDetailsReportRoute } from '@/lib/constants/routes'
export default {
  props: [
    'commissionReportItems'
  ],
  data () {
    return {
      headers: [
        { text: 'Internal Employee', value: 'employeeName', class: 'pl-4 pr-0', width: '17%' },
        { text: 'Commission', value: 'totalCommission', class: 'pl-4 pr-0', width: '13%' },
        { text: 'Consultants GP', value: 'consultantsGP', class: 'pl-4 pr-0', width: '14%' },
        { text: 'Perm. Placements GP', value: 'permPlacementsGP', class: 'pl-4 pr-0', width: '20%' },
        { text: 'Individual GP', value: 'totalIndividualGP', class: 'pl-4 pr-0', width: '13%' },
        { text: 'Override', value: 'commissionOverride', class: 'pl-4 pr-0', width: '10%' },
        { text: 'Details', sortable: false, value: 'actions', align: 'center', width: '12%', class: 'hide-on-print', cellClass: 'hide-on-print' }
      ]
    }
  },
  computed: {
    ...mapFields('commissionReportFilters', [
      'userId',
      'year',
      'month'
    ])
  },
  methods: {
    viewCommissionDetails (event, item) {
      const routeData = this.$router.resolve({
        name: commissionDetailsReportRoute.name,
        query: {
          user: item.employeeUserId,
          year: this.year,
          month: this.month
        }
      })
      if (event.ctrlKey === true) {
        window.open(routeData.href, '_blank')
      } else {
        window.open(routeData.href, '_self')
      }
    }
  }
}
</script>
